// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchBar_search-container__TY-Q5 {
  z-index: 1;
  width: 80%;
  max-width: 1080px;
}
.SearchBar_search-container__TY-Q5 .SearchBar_search-bar__9Xleq {
  margin: auto;
  background-color: #ffffff;
  border-radius: 80px;
  display: flex;
  align-items: center;
  padding: 10px 25px;
  width: 100%;
}
.SearchBar_search-container__TY-Q5 .SearchBar_search-bar__9Xleq input {
  flex: 1 1;
  border: none;
  outline: none;
  padding-right: 20px;
  font-size: 20px;
  overflow: auto;
}
.SearchBar_search-container__TY-Q5 .SearchBar_search-bar__9Xleq .SearchBar_search__NEAVF {
  color: black;
}

.SearchBar_search-container-navbar__13l32 {
  z-index: 1;
  width: 100%;
}
.SearchBar_search-container-navbar__13l32 .SearchBar_search-bar__9Xleq {
  margin: auto;
  background-color: #393939;
  border-radius: 80px;
  display: flex;
  align-items: center;
  padding: 10px 25px;
  width: 100%;
  height: 40px;
}
.SearchBar_search-container-navbar__13l32 .SearchBar_search-bar__9Xleq input {
  flex: 1 1;
  border: none;
  outline: none;
  padding-right: 20px;
  font-size: 16px;
  overflow: auto;
  background-color: #393939;
  color: #bbbbbb;
}
.SearchBar_search-container-navbar__13l32 .SearchBar_search-bar__9Xleq ::placeholder {
  color: #bbbbbb;
}
.SearchBar_search-container-navbar__13l32 .SearchBar_search-bar__9Xleq .SearchBar_search__NEAVF {
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/common/SearchBar/SearchBar.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,UAAA;EACA,UAAA;EACA,iBAAA;AAFF;AAIE;EACE,YAAA;EACA,yBCDI;EDEJ,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAFJ;AAII;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eElBK;EFmBL,cAAA;AAFN;AAKI;EACE,YAAA;AAHN;;AAQA;EACE,UAAA;EACA,WAAA;AALF;AAOE;EACE,YAAA;EACA,yBChCc;EDiCd,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AALJ;AAOI;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,yBC/CY;EDgDZ,cCzBQ;ADoBd;AAQI;EACE,cC7BQ;ADuBd;AASI;EACE,cCrDE;AD8CR","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.search-container {\n  z-index: 1;\n  width: 80%;\n  max-width: 1080px;\n\n  .search-bar {\n    margin: auto;\n    background-color: colors.$white;\n    border-radius: 80px;\n    display: flex;\n    align-items: center;\n    padding: 10px 25px;\n    width: 100%;\n\n    input {\n      flex: 1;\n      border: none;\n      outline: none;\n      padding-right: 20px;\n      font-size: typography.$header-s;\n      overflow: auto;\n    }\n\n    .search {\n      color: black;\n    }\n  }\n}\n\n.search-container-navbar {\n  z-index: 1;\n  width: 100%;\n\n  .search-bar {\n    margin: auto;\n    background-color: colors.$secondary-hover;\n    border-radius: 80px;\n    display: flex;\n    align-items: center;\n    padding: 10px 25px;\n    width: 100%;\n    height: 40px;\n\n    input {\n      flex: 1;\n      border: none;\n      outline: none;\n      padding-right: 20px;\n      font-size: 16px;\n      overflow: auto;\n      background-color: colors.$secondary-hover;\n      color: colors.$neutral-400;\n    }\n\n    ::placeholder {\n      color: colors.$neutral-400;\n    }\n\n    .search {\n      color: colors.$white;\n    }\n  }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-container": `SearchBar_search-container__TY-Q5`,
	"search-bar": `SearchBar_search-bar__9Xleq`,
	"search": `SearchBar_search__NEAVF`,
	"search-container-navbar": `SearchBar_search-container-navbar__13l32`
};
export default ___CSS_LOADER_EXPORT___;
